import { IStore } from '../../store';
import { TBallastActions } from './actions';
import { IAuthActions } from '../auth/actions';
import ballastHistoryMiddleware from './middlewares/history.middleware';
import createMiddleware from '../../_core/create-middleware';
import ballastTableLogsMiddleware from './middlewares/table-logs.middleware';
// import ballastRestrictionsMiddleware from './middlewares/restrictions.middleware';

const ballastBaseMiddleware = createMiddleware<
    IStore,
    TBallastActions | IAuthActions
>()
    .getMiddleware();

const ballastMiddlewares = [
    ballastBaseMiddleware,
    ballastHistoryMiddleware,
	ballastTableLogsMiddleware,
];

export default ballastMiddlewares;
